/* mazo-units.js (2026-10-15, owner: "if I select inch in the PDP, and click on what's my size, inch should be selected
   automatically.. but still show the switch").
   Every cm / inch switch on the site (the live measurement line on the product page, the "What's my size" sheet, the
   size guide page) is a pair of radios whose CSS shows one unit. This keeps them all on the same unit: pick inch in
   one, every other switch on the page flips to inch too, and the choice is remembered for the next page
   (sessionStorage, key "mazo-unit", this visit only since 2026-10-28). Switches are found by structure (a `*__units` group holding cm / in radios), so a
   new chart or sheet needs no change here. No switch is hidden; the shopper can still flip back. */
(function () {
  if (window.mazoUnits) return;
  window.mazoUnits = true;
  var KEY = 'mazo-unit';
  /* 2026-10-28 (owner: "on desktop it is default showing inch, please make it cm"): the shopper's pick used to be kept in
     localStorage for ever, so one tap on inch made every later visit open on inch. Now it is kept for the visit only
     (sessionStorage); every new visit starts on cm. The old forever key is removed. */
  var store = window.sessionStorage;
  try { localStorage.removeItem(KEY); } catch (err) { /* ignore */ }
  var SEL = '[class*="__units"] input[type="radio"][value="cm"], [class*="__units"] input[type="radio"][value="in"]';

  var current = null;   // the unit the shopper last picked (or the remembered one); null = leave each chart's default

  function setAll(unit, source) {
    current = unit;
    document.querySelectorAll(SEL).forEach(function (r) {
      /* skip the hidden OLD copy Dawn keeps for 500 ms after a size change: it shares the radio group with the new copy,
         and ticking it would UNCHECK the visible one (the cm flash, 2026-10-19). */
      if (r.closest('[style*="display: none"]')) return;
      if (r !== source && r.value === unit && !r.checked) r.checked = true;
    });
  }

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r.matches || !r.matches(SEL) || !r.checked) return;
    setAll(r.value, r);
    try { store.setItem(KEY, r.value); } catch (err) { /* private mode: sync still works on this page */ }
  }, true);   // CAPTURE: product-info.js stops these change events in the capture phase so the variant code never sees them

  /* 2026-10-28 (owner: "the entire switch is what the user clicks: press inch and it turns to inch, press again and it
     becomes cm"). A tap anywhere on a cm / inch switch flips it to the OTHER unit. The label's own click is cancelled so the
     browser does not also tick the radio it was aimed at; the flip is made here and announced with the same `change`
     event a real tick sends, so mazo-units / product-info.js keep every other switch and the variant code in step.
     A click that starts on the radio itself (keyboard space / arrows) is left alone. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var g = t.closest('.mazo-seg[class*="__units"]');
    if (!g || (t.matches && t.matches('input'))) return;
    var cm = g.querySelector('input[value="cm"]'), inch = g.querySelector('input[value="in"]');
    if (!cm || !inch) return;
    e.preventDefault();
    var next = cm.checked ? inch : cm;
    next.checked = true;
    next.dispatchEvent(new Event('input', { bubbles: true }));
    next.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  function restore() {
    var unit = null;
    try { unit = store.getItem(KEY); } catch (err) { unit = null; }
    if (unit === 'cm' || unit === 'in') setAll(unit, null);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore);
  else restore();
  /* the size sheet and quick views can be rendered later (section rendering): match them when they appear */
  new MutationObserver(function () {
    if (current) setAll(current, null);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
